// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__OLOYe","header":"style_header__dljwQ","small":"style_small__fCLSA","description":"style_description__Bqhoi"};